
/**
 * @function
 * @name useGetCompanyListByFirmId
 * @param {number} firmId
 * @description Hook that fetches the company list by the firm id
 * @returns {Promise<any[]>}
 */

import {useCallback} from 'react';
import {ApiService} from 'api';
import {companiesAction, globalAction} from 'common/actions';
import {useStore} from 'common/store';
import { UseStoreValues } from 'common/types/store';
import useResponse from 'services/hooks/useResponse';

export const useGetCompanyListByFirmId = () => {
  const [, dispatch] = useStore() as unknown as UseStoreValues;
  const { processErrorResponse } = useResponse();

  const getCompanies = useCallback(
    async (firmId: number): Promise<any[]> => {
      if (firmId) {
        try {
          dispatch(globalAction.showLoadingProgress(true));
          const companies = await ApiService.apiFirmsCompaniesList(firmId.toString());
          dispatch(companiesAction.setCompanyList(companies));
          return companies;
        } catch (error) {
          dispatch(companiesAction.setCompanyList([]));
          const defaultErrorMessage = 'An error occurred while loading Companies';
          processErrorResponse({
            error,
            defaultErrorMessage,
            action: 'get companies',
          });
        } finally {
          dispatch(globalAction.showLoadingProgress(false));
        }
      }
      return [];
    },
    [dispatch, processErrorResponse]
  );

  return { getCompanies };
};
